export const ENTITIES_LABEL = 'Entities';
export const VIRTUAL_ENTITIES_LABEL = 'Virtual Entities';
